<template>
  <section class="a-hero" aria-labelledby="adjudicacion-hero-title">
    <div class="a-hero__content">
      <span class="a-hero__tag">Tu progreso cuenta</span>

      <div class="a-hero__text">
        <h1 id="adjudicacion-hero-title" class="wd-title">
          <span class="a-hero__base">Estás a un paso</span> <br class="br-d" /><span class="hl"
            >de recibir tu financiamiento</span
          >
        </h1>
        <p class="wd-body">
          Conoce cómo funciona la adjudicación <br class="br-d" />y qué necesitas para avanzar sin contratiempos.
        </p>
      </div>

      <div class="a-hero__text">
        <h2 class="a-hero__subtitle">¿Qué es la adjudicación?</h2>
        <p class="wd-body">
          Tu camino está dividido en etapas claras. <br class="br-d" />Aquí puedes entender en cuál estás y qué sigue:
        </p>
      </div>

      <ul class="a-hero__items">
        <li v-for="item in items" :key="item.text">
          <img :src="item.icon" alt="" aria-hidden="true" />
          <p class="wd-body" v-html="item.text" />
        </li>
      </ul>

      <div class="a-hero__actions">
        <router-link :to="{ hash: '#adjudicacion-formas' }" class="a-hero__button a-hero__button--primary">
          <span>Entender la adjudicación</span>
          <img :src="arrowWhite" alt="" aria-hidden="true" />
        </router-link>
        <router-link :to="{ name: 'cliente-cliente-financiamiento' }" class="a-hero__button a-hero__button--secondary">
          <span>Ver mi estatus</span>
          <img :src="arrowPurple" alt="" aria-hidden="true" />
        </router-link>
      </div>
    </div>

    <img class="a-hero__image" :src="heroImage" alt="Pareja celebrando su nuevo hogar" />
  </section>
</template>

<script setup lang="ts">
import heroImage from '../../../assets/adjudicacion-figma/hero.jpg'
import peopleIcon from '../../../assets/adjudicacion-figma/bullet-people.svg'
import houseIcon from '../../../assets/adjudicacion-figma/bullet-house.svg'
import paperIcon from '../../../assets/adjudicacion-figma/bullet-paper.svg'
import arrowWhite from '../../../assets/adjudicacion-figma/arrow-white.svg'
import arrowPurple from '../../../assets/adjudicacion-figma/arrow-purple.svg'

const items = [
  { icon: peopleIcon, text: 'Es el proceso donde se asigna quién recibe <br class="br-d">el financiamiento' },
  { icon: houseIcon, text: 'Participan clientes al corriente en pagos' },
  { icon: paperIcon, text: 'Se basa en reglas claras del contrato' }
]
</script>

<style scoped>
.a-hero {
  display: flex;
  align-items: stretch;
  overflow: hidden;
  background: var(--ds-grey-50);
  border-radius: 24px;
}

.a-hero__content {
  display: flex;
  flex: 0 0 493px;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--ds-space-6);
  padding: var(--ds-space-6) var(--ds-space-4);
  box-sizing: border-box;
}

.a-hero__tag {
  padding: var(--ds-space-3);
  border-radius: 9999px;
  background: var(--ds-tag-orange-fill);
  color: var(--ds-tag-orange-text);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}

.a-hero__text {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-3);
  width: 100%;
}
.a-hero .wd-title {
  color: var(--ds-purple-900);
}
.a-hero__base {
  color: var(--ds-purple-900);
}
.a-hero .wd-title .hl {
  color: #6d59ea;
}

.a-hero__subtitle {
  margin: 0;
  color: var(--ds-purple-900);
  font-family: var(--ds-font-family-bebas);
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
}

.a-hero__items {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-6);
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}
.a-hero__items li {
  display: flex;
  align-items: center;
  gap: var(--ds-space-3);
  min-height: 40px;
}
.a-hero__items img {
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
}

.a-hero__actions {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-5);
  width: 100%;
}
.a-hero__button {
  text-decoration: none;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--ds-space-3);
  width: 100%;
  height: 48px;
  padding: 10px var(--ds-space-4);
  box-sizing: border-box;
  border-radius: 24px;
  font-family: var(--ds-font-family-base);
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  cursor: pointer;
}
.a-hero__button img {
  width: 24px;
  height: 24px;
}
.a-hero__button--primary {
  border: 0;
  background: var(--ds-purple-500);
  color: #fff;
}
.a-hero__button--secondary {
  border: 1px solid var(--ds-purple-500);
  background: var(--ds-grey-50);
  color: var(--ds-purple-500);
}

.a-hero__image {
  flex: 1 1 0;
  min-width: 0;
  height: auto;
  object-fit: cover;
  border-radius: 0 24px 24px 0;
}

@media (max-width: 1024px) {
  .a-hero__content {
    flex: 1 1 0;
    min-width: 0;
    padding: var(--ds-space-6) var(--ds-space-5);
  }
  .a-hero__items li {
    min-height: 48px;
  }
}

@media (max-width: 599px) {
  .a-hero {
    flex-direction: column;
  }
  .a-hero__content {
    flex: none;
    padding: var(--ds-space-6) var(--ds-space-4) 0;
  }
  .a-hero__image {
    flex: none;
    width: calc(100% - 2 * var(--ds-space-4));
    height: 328px;
    margin: var(--ds-space-6) var(--ds-space-4);
    border-radius: 24px;
  }
}
</style>
